<template>
    <div class="works">
        <h1 class="title has-text-weight-light ">WORKS</h1>
        <div class="container">
            <p class="subtitle has-text-left">ALBUM</p>
            <div class="columns is-multiline is-mobile">
                <modal class="column is-2-desktop" v-bind:link="work.link" v-bind:src="work.src" v-bind:text="work.text" v-bind:subtitle="work.subtitle"
                       v-bind:title="work.title" v-for="work in music" v-bind:linkname="work.linkname" v-bind:key="work.id"></modal>
            </div>
            <p class="subtitle has-text-left">collaboration</p>
            <div class="columns is-multiline is-mobile">
                <modal class="column is-2-desktop" v-bind:link="work.link" v-bind:src="work.src" v-bind:text="work.text" v-bind:subtitle="work.subtitle"
                       v-bind:title="work.title" v-bind:linkname="work.linkname" v-for="work in collaboration" v-bind:key="work.id"></modal>
            </div>
            <p class="subtitle has-text-left">OTHER</p>
            <div class="columns is-multiline is-mobile">
                <modal class="column is-2-desktop" v-bind:link="work.link" v-bind:src="work.src" v-bind:text="work.text" v-bind:subtitle="work.subtitle"
                       v-bind:title="work.title" v-bind:linkname="work.linkname" v-for="work in others" v-bind:key="work.id"></modal>
            </div>


        </div>
    </div>
</template>

<script>
    import modal from "../components/modal";

    export default {
        name: "WORKs",
        components: {modal},
        methods: {
            modal: function () {

            }

        },
        data() {
            return {
                music: [
                    {
                        id: 1,
                        title: 'elements',
                        text: '現世の理をテーマにしたコンピレーションアルバム、登場。',
                        src: '/img/CD/elements.jpg',
                        link: 'https://soundcloud.com/next_arco_recordings/concreate-1st-compilation-album-elements-x-fade-demo',
                        linkname:'視聴はこちらから',
                        subtitle:'―汝、万物の理を知れ'
                    },
                    {
                        id: 2,
                        title: '秋麗',
                        text: '秋をテーマにした、セカンドアルバム。\n' +
                            '誰も足を踏み入れたことのない世界を、あなたは体感する…。',
                        src: '/img/CD/syuurei.png',
                        link:'https://soundcloud.com/ishihira/concreate-second-album-x-fade-sample',
                        linkname:'視聴はこちらから',
                        subtitle: '進化する秋。そして新時代へ───'
                    },
                    {
                        id: 3,
                        title: 'ConJungate',
                        text: 'え、今度のアルバムは無秩序、無機質！？\n' +
                            '全曲が混沌としていて、何気にポップ！！\n' +
                            'ほとんどが歌詞付き、サイコドラゴン先生地獄。\n' +
                            'それらを支えるように、いしひらとサイガーゆきのんの新曲！\n' +
                            'そして、サークル外から豪華なスペシャルサンクスも！\n' +
                            '漫画『無限大レイドロン』の劇中BGMも収録！\n' +
                            'ConCreate、問題の3rdアルバム。',
                        src: '/img/CD/Conjungle.jpg',
                        link: 'https://soundcloud.com/cre-con/conjugate-x-fade',
                        linkname:'視聴はこちらから',
                        subtitle:'全力、アナーキー！'
                    },
                    {
                        id: 4,
                        title: 'Con-Creators 2016',
                        text: 'Con Create初のCD頒布！\n' +
                            'Con-Creatorsの総力をかけた豪華ラインナップ！\n' +
                            '\n' +
                            '2016年の最先端を行くサウンドや、\n' +
                            '80年代へのタイムスリップのような実験曲など、\n' +
                            '過去を生きてきた大人から、昨今の音楽ブーム渦中の若者まで\n' +
                            '全世代を巻き込む、衝撃の4rdアルバム。\n' +
                            '\n' +
                            'その予測不能な展開を体感せよ……',
                        src: '/img/CD/Con-Creators.jpg',
                        link: 'https://con-creators-2016.tumblr.com',
                        linkname:'特設サイトはこちらから',
                        subtitle:'パワフル×メロディック=2016！'
                    },
                    {
                        id: 5,
                        title: 'Druggy x Druggy',
                        text: 'Con Create初のM3参戦！\n' +
                            '薬をテーマにした楽曲が収録されています。\n' +
                            'かゆみ止めから始まり、解毒剤、子供用かぜぐすりに漢方薬、さらには架空の薬など幅広く提供！？\n' +
                            '大人気「ラブポリープ」シリーズ第3弾『抗ポリープ剤』にて本シリーズは完結！\n' +
                            '竹内ハルキ先生、キーとさんに加え新ゲスト「あずきバー」の皆さんがスペシャルサンクスに登場！\n' +
                            '今年度の新入生も早速アルバムに参加しております。\n' +
                            '薬漬けのConCreateによる、ドラッギーでジャンキーな5thアルバム。\n' +
                            '\n' +
                            'Choose your drug──薬を選べ。',
                        src: '/img/CD/druggy.jpg',
                        link: 'https://druggy-x-druggy.tumblr.com',
                        linkname:'特設サイトはこちら',
                        subtitle:'Choose your drug──'
                    },
                    {
                        id: 6,
                        title: '新入生コンピ',
                        text: '新入生を迎え新体制となったConCreate!\n' +
                            'ConCreate至上初の新入生コンピ！！ 是非お聞きください！ \n' +
                            'クロスフェードもお聞きください。 ',
                        src: '/img/CD/shinnyuu.jpg',
                        link: 'https://concreate-freshman-2017.tumblr.com',
                        linkname:'特設サイトはこちら',
                        subtitle:''
                    },
                    {
                        id: 7,
                        title: '淡雪',
                        text: 'Con Create２度目のM3挑戦！\n' +
                            '和をテーマとした上品かつ大胆な楽曲たち\n' +
                            '『古き良き和の心』と『革新的な現代』の融合が生み出す楽曲群 \n' +
                            '1回生も参戦し、新たな風が吹き込んだアルバムになっています。\n' +
                            'ぜひクロスフェードもお聞きください。\n' +
                            'ConCreateによる、風情漂う7thアルバム。',
                        src: '/img/CD/awayuki.jpg',
                        link: 'https://2017autumn-m3-awayuki.tumblr.com',
                        linkname:'特設サイトはこちら',
                        subtitle:'和を以て貴しとなす'
                    },
                    {
                        id: 8,
                        title: 'FORCE BEAT',
                        text: '次のコンピは何する？\n' +
                            'うーん、四つ打ちコンピとか…？\n' +
                            'じゃあそれで！\n' +
                            '\n' +
                            'そんなノリで始まった今回のアルバム、四つ打ちコンピ\n' +
                            '四つ打ちというざっくりとしたコンセプトを決め、各々の解釈が生み出した四つ打ちの曲目群\n' +
                            '\n' +
                            '果たしてそれは、どのような曲へと昇華されるのだろうか…？\n' +
                            '\n' +
                            'ConCreateメンバーがお送りするミニアルバム\n' +
                            '四つ打ちコンピ FORCE BEAT、公開開始！！\n' +
                            '\n' +
                            'ぜひクロスフェードもお聞きください。 ',
                        src: '/img/CD/yotuuti.jpg',
                        link: 'https://soundcloud.com/cre-con/concreate-the-7th-album-force-beat-x-fade-sample',
                        linkname:'視聴はこちら',
                        subtitle:''
                    },
                    {
                        id: 9,
                        title: '「」',
                        text: '今回のテーマはなんと無！\n' +
                            'テーマが難しく各々が苦労しましたがなんとか完成出来ました！\n' +
                            'ConCreateメンバーがお送りする8thアルバム\n' +
                            '『「」』、公開開始！！\n' +
                            '\n' +
                            'ぜひクロスフェードもお聞きください。 ',
                        src: '/img/CD/mu.jpg',
                        link: 'https://concreate-mu.tumblr.com',
                        linkname:'視聴はこちらから',
                        subtitle:''
                    },
                    {

                        id:10,
                        title:'Con-creators2019',
                        text:'10/27開催のM3にて新アルバム『Con-Creators2019』を頒布します！\n' +
                            '各々が全力を出し切った傑作ぞろいとなっています！\n' +
                            '新鋭も加わりますます強く進化したConCreateをとくとご覧あれ！\n',
                        src:'/img/CD/concreators2019.png',
                        link:'https://m3you-4ee66.firebaseapp.com',
                        linkname:'特設サイトはこちら！',
                        subtitle:'--2019--'
                    }
                ],
                collaboration:[
                    {
                        id: 1,
                        title: 'Instrument Cross Parade',
                        text: '音見鶏とCon-Createのコラボコンピです！\n' +
                            '両サークルからそれぞれ1人ずつ、同じ1つの音色をフィーチャーした曲を作ってみました。\n' +
                            '音色は7つ、曲数は14曲です。\n' +
                            '音色の使い方に現れる個性にご注目ください！\n' +
                            '\n',
                        src: '/img/CD/icp.png',
                        link:'http://www.otomidori.at-ninja.jp/joint/concreate/icp.html',
                        linkname:'特設サイトはこちら！',
                        subtitle:'～Con-Create & 音見鶏 音色縛りコンピ～'
                    },
                    {
                        id: 2,
                        title: 'No Light No Darkness',
                        text: 'この世の音楽は2種類に分けられる。\n' +
                            '治安がいいか、それとも悪いか…\n' +
                            '\n' +
                            'Rum RaisinXConCreateコンピレーションアルバム\n' +
                            '\n' +
                            '"No Light No Darkness"\n' +
                            '\n' +
                            '総勢16名が参加したこのアルバム今すぐwebからダウンロード！\n' +
                            'ぜひクロスフェードもお聞きください。 ',
                        src: '/img/CD/no_light_no_darkness.jpg',
                        link: 'https://soundcloud.com/cre-con/concreate-x-rum-raisinno-light-no-darkness-x-fade-sample',
                        linkname:'視聴はこちら！',
                        subtitle:''
                    },
                    {
                        id:3,
                        title:'Stargazer',
                        text:'.｡..｡.:*･\'アルバム公開\'･*:.｡. .｡.\n' +
                            '神戸大学の音見鶏とのコラボアルバム『Stargazer』がついにリリース！！\n' +
                            '\n' +
                            '宵闇を切り裂く星々の煌めきが奏でる調は何億光年先までも届く\n' +
                            '\n' +
                            'ぜひ貴方も星の旋律に酔いしれてはいかがでしょうか\n',
                        src:'/img/CD/otomi.png',
                        link: 'http://www.otomidori.at-ninja.jp/joint/concreate/stargazer.html',
                        linkname:'特設サイトはこちら！',
                        subtitle:''

                    }
                ],
                others:[
                    {

                    }
                ]
            }
        }
    }
    </script>

<style scoped>
    h1 {
        text-align: left;
        margin-left: 20px;
    }

    .container {
        margin: 20px;
    }
</style>